//
// Legend.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "../layoutOverlay/AutoAlignPositions";
import "../core/styles/FillAttributes";
import "../core/styles/LineAttributes";
import "./LegendLocation";
import "../core/Pad";
import "../core/styles/TextAttributes";
import "../core/HorizontalAlignment";
import "../core/VerticalAlignment";

var Legend = createModule("gtl::Legend", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        border: 2,
        titleAttributes: 1,
        opaque: 2,
        hAlign: 4,
        outerPad: 1,
        autoAlign: 1,
        backgroundAttributes: 1,
        title: 7,
        vAlign: 4,
        pad: 1,
        valueAttributes: 1,
        borderAttributes: 1,
        location: 4,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default Legend;
